<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsPie',
  
})
</script>
<template>
  <v-chart
    class="tlbs-pie"
    :option="option"
    :autoresize="true"
  />
</template>

<script lang="ts" setup name="TlbsPie">
import * as echarts from 'echarts/core';
import VChart from 'vue-echarts';
import {
  TooltipComponentOption,
  LegendComponentOption,
} from 'echarts/components';
import { PieSeriesOption } from 'echarts/charts';
import cloneDeep from 'lodash/cloneDeep';

type EChartsOption = echarts.ComposeOption<
TooltipComponentOption | LegendComponentOption | PieSeriesOption
>;

interface DataItem {
  value: number;
  name: string;
  itemStyle: {
    color: string;
  }
}

interface Props {
  data: DataItem[];
  itemStyle: LooseObject;
  label: LooseObject;
  labelLine: LooseObject;
  color: string[];
  legend: EChartsOption['legend'];
  radius: number | string | string[] | number[];
  serieConfig: LooseObject;
  tooltip: LooseObject
}

const props = withDefaults(defineProps<Props>(), {
  data: () => [],
  color: () => [],
  legend: () => ({}),
  itemStyle: () => ({}),
  label: () => ({}),
  labelLine: () => ({}),
  serieConfig: () => ({}),
  tooltip: () => ({}),
  radius: '30%',
});

const getOption = (): EChartsOption => {
  const data = props.data.map((item, index) => {
    const itemOption = cloneDeep(item);
    itemOption.itemStyle = item.itemStyle || {};
    if (props.color[index]) {
      itemOption.itemStyle.color = props.color[index];
    }
    return itemOption;
  });
  const serie: PieSeriesOption = {
    type: 'pie',
    radius: props.radius,
    data,
    ...props.serieConfig,
  };
  if (props.itemStyle) {
    serie.itemStyle = props.itemStyle;
  }
  if (props.label) {
    serie.label = props.label;
  }
  if (props.labelLine) {
    serie.labelLine = props.labelLine;
  }
  const option: EChartsOption = {
    tooltip: props.tooltip,
    legend: props.legend,
    series: [serie],
  };

  return option;
};

const option = ref<EChartsOption>(getOption());

watch(props, () => {
  option.value = getOption();
});


</script>
